import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { navigationMenu, navigationSideMenu } from "./shared/constraints";
import { Cross, CrossIcon } from "lucide-react";
import { Button } from "react-bootstrap";
import { MdCancel } from "react-icons/md";
import Swal from "sweetalert2";

const Sidebar = ({ sidebarOpen, handleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");
  // ALL STATE
  const sidebarData =
    userType == "member" ? navigationSideMenu : navigationMenu;

  const handleLogout = () => {
    Swal.fire({
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Logout",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user-type");
        navigate("/");
      }
    });
  };

  return (
    <div className={`pb-0 sidebar-pages ${sidebarOpen ? "openSidebar" : ""}`}>
      <Button
        className="close-icon-sidebar bg-transparent border-0 position-absolute end-0 d-lg-none d-block"
        onClick={() => handleSidebar()}
      >
        <MdCancel className="fs-3" />
      </Button>
      <div className="sidebar-logo d-lg-none d-block mb-3">
        <Link to="/">
          <img src="../assets/images/logo.png" alt="" className="" />
        </Link>
      </div>
      <ul>
        {sidebarData &&
          sidebarData?.map((menuItem, index) => (
            <li key={index} onClick={() => handleSidebar()}>
              <Link
                to={menuItem?.path}
                className={location.pathname === menuItem.path ? "active" : ""}
              >
                {menuItem.name}
              </Link>
            </li>
          ))}
        <li>
          <Button
            onClick={() => handleLogout()}
            className="bg-transparent border-0 logout-button ps-3"
          >
            Logout
          </Button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
